import React, {
    useEffect,
    useState,
    useMemo,
    useContext
}
from "react";

import { functions }
from "../../../../constants/common-functions";

import { store }
from "../../../../context/store";


export default function DeskDrawer({
    desk,
    onClose,
    workplaceActivities
})
{
    //--------------------------------------------------------
    // State / context
    //--------------------------------------------------------

    const [timelineData, setTimelineData] =
        useState({});

    const globalState =
        useContext(store);

    const filterBean =
    {
    };

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // Activity map
    //--------------------------------------------------------

    const activityMap =
        useMemo(
            function()
            {
                const map =
                {
                };

                if(
                    workplaceActivities?.length
                )
                {
                    workplaceActivities.forEach(
                        function(a)
                        {
                            map[a.id] = a;
                        }
                    );
                }

                return map;
            },
            [workplaceActivities]
        );


    //--------------------------------------------------------
    // Structure
    //--------------------------------------------------------

    const isOpen =
        !!desk;

    const item =
        desk;

    const selectedDate =
        desk?.selectedDate;

    const isSingleDay =
        !!selectedDate;

    const isMulti =
        !(
            item?.type
                ?.toUpperCase()
                .startsWith("A")
        );

    const allDays =
        desk?.allDates || [];

    const days =
        isSingleDay
            ? [selectedDate]
            : allDays;

    const hours =
    [
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00"
    ];


    //--------------------------------------------------------
    // Load data
    //--------------------------------------------------------

    useEffect(
        function()
        {
            if(
                !desk
                ||
                !item?.spaceId
            )
            {
                return;
            }

            functions.postFilterBeanAjax(
                "/resolutionsoftwareplatform/usageinspector/usageinspectordetail"
                    + "?spaceId="
                    + item.spaceId,

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                function(response)
                {
                    const newTimeline =
                    {
                    };

                    response.forEach(
                        function(day)
                        {
                            newTimeline[day.date] =
                                day.hours || [];
                        }
                    );

                    setTimelineData(
                        newTimeline
                    );
                },

                null
            );

        },
        [desk]
    );


    //--------------------------------------------------------
    // Get hour data
    //--------------------------------------------------------

    function getHourData(
        date,
        hourStr
    )
    {
        const hourInt =
            parseInt(
                hourStr.split(":")[0],
                10
            );

        const dayData =
            timelineData[date] || [];

        return (
            dayData.find(
                function(h)
                {
                    return h.hour === hourInt;
                }
            )
            ||
            null
        );
    }


    //--------------------------------------------------------
    // Resolve activity
    //--------------------------------------------------------

    function resolveActivity(record)
    {
        if(
            !record
        )
        {
            return {
                label:
                    "No Data",

                background:
                    "#475569",

                opacity:
                    0.5
            };
        }

        if(
            !record.activityId
        )
        {
            return {
                label:
                    "No Activity",

                background:
                    "#1e293b"
            };
        }

        const activity =
            activityMap[
                record.activityId
            ];

        if(
            !activity
        )
        {
            return {
                label:
                    "Unknown",

                background:
                    "#6b7280"
            };
        }

        const colour =
            activity.color
            ||
            activity.colour;

        return {
            label:
                activity.name,

            background:
                colour
                    ? `${colour}CC`
                    : "#f97316"
        };
    }


    //--------------------------------------------------------
    // Desk style
    //--------------------------------------------------------

    function getDeskStyle(record)
    {
        if(
            !record
        )
        {
            return {
                background:
                    "#475569",

                opacity:
                    0.6
            };
        }

        if(
            record.occupied
        )
        {
            return {
                background:
                    "#ef4444"
            };
        }

        if(
            record.signsOfLife
        )
        {
            return {
                background:
                    "#3b82f6"
            };
        }

        return {
            background:
                "#22c55e"
        };
    }


    //--------------------------------------------------------
    // Desk label
    //--------------------------------------------------------

    function getDeskLabel(record)
    {
        if(
            !record
        )
        {
            return "No Data";
        }

        if(
            record.occupied
        )
        {
            return "Occupied";
        }

        if(
            record.signsOfLife
        )
        {
            return "SOL";
        }

        return "Vacant";
    }


    //--------------------------------------------------------
    // Type label
    //--------------------------------------------------------

    function getTypeLabel()
    {
        return (
            item?.type
            ||
            "Workplace"
        );
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            style={{
                position:
                    "fixed",

                top:
                    "77px",

                right:
                    0,

                bottom:
                    0,

                width:
                    isSingleDay
                        ? "420px"
                        : "90%",

                maxWidth:
                    isSingleDay
                        ? "420px"
                        : "1100px",

                background:
                    "#0f172a",

                color:
                    "#e5e7eb",

                boxShadow:
                    "-12px 0 40px rgba(0,0,0,0.6)",

                transform:
                    isOpen
                        ? "translateX(0)"
                        : "translateX(100%)",

                transition:
                    "all 0.4s cubic-bezier(.22,.61,.36,1)",

                zIndex:
                    2000,

                display:
                    "flex",

                flexDirection:
                    "column"
            }}
        >

            {/* ------------------------------------------------
                Header
                ------------------------------------------------ */}

            <div
                style={{
                    padding:
                        "20px",

                    borderBottom:
                        "2px solid #20afe8",

                    background:
                        "linear-gradient("
                        + "180deg,"
                        + "rgba(255,255,255,0.025) 0%,"
                        + "rgba(255,255,255,0) 100%"
                        + ")"
                }}
            >

                <h2
                    style={{
                        margin:
                            0
                    }}
                >
                    {item?.code}
                </h2>

                <div
                    style={{
                        color:
                            "#94a3b8",

                        marginTop:
                            "4px"
                    }}
                >

                    {getTypeLabel()}

                    {
                        selectedDate
                        &&
                        (
                            <span
                                style={{
                                    marginLeft:
                                        "8px",

                                    color:
                                        "#38bdf8"
                                }}
                            >
                                • {selectedDate}
                            </span>
                        )
                    }

                </div>

            </div>


            {/* ------------------------------------------------
                Body
                ------------------------------------------------ */}

            <div
                style={{
                    flex:
                        1,

                    overflowX:
                        "auto",

                    padding:
                        "20px"
                }}
            >

                <div
                    style={{
                        display:
                            "flex",

                        gap:
                            "12px",

                        minWidth:
                            isSingleDay
                                ? "100%"
                                : "800px"
                    }}
                >

                    {
                        days.map(
                            function(day)
                            {
                                return (

                                    <div
                                        key={day}
                                        style={{
                                            minWidth:
                                                isSingleDay
                                                    ? "100%"
                                                    : "180px",

                                            background:
                                                "rgba(255,255,255,0.045)",

                                            border:
                                                "1px solid rgba(255,255,255,0.06)",

                                            borderRadius:
                                                "0px",

                                            padding:
                                                "10px",

                                            boxShadow:
                                                "0 6px 18px rgba(0,0,0,0.14)"
                                        }}
                                    >

                                        {/* Day */}

                                        <div
                                            style={{
                                                textAlign:
                                                    "center",

                                                marginBottom:
                                                    "10px",

                                                fontWeight:
                                                    "bold"
                                            }}
                                        >
                                            {day}
                                        </div>


                                        {/* Hours */}

                                        {
                                            hours.map(
                                                function(h)
                                                {
                                                    const record =
                                                        getHourData(
                                                            day,
                                                            h
                                                        );

                                                    const resolved =
                                                        resolveActivity(
                                                            record
                                                        );


                                                    //------------------------------------------------
                                                    // Multi-capacity space
                                                    //------------------------------------------------

                                                    if(
                                                        isMulti
                                                    )
                                                    {
                                                        const used =
                                                            record?.capacityUsed
                                                            ??
                                                            0;

                                                        const cap =
                                                            item?.capacity
                                                            ??
                                                            0;

                                                        return (

                                                            <div
                                                                key={h}
                                                                style={{
                                                                    marginBottom:
                                                                        "8px",

                                                                    padding:
                                                                        "8px",

                                                                    //------------------------------------------------
                                                                    // Flat - tiny radius retained on data cells
                                                                    //------------------------------------------------

                                                                    borderRadius:
                                                                        "2px",

                                                                    color:
                                                                        "#fff",

                                                                    minHeight:
                                                                        "52px",

                                                                    display:
                                                                        "flex",

                                                                    flexDirection:
                                                                        "column",

                                                                    justifyContent:
                                                                        "space-between",

                                                                    background:
                                                                        resolved.background,

                                                                    opacity:
                                                                        resolved.opacity
                                                                        ??
                                                                        1
                                                                }}
                                                            >

                                                                <div
                                                                    style={{
                                                                        fontSize:
                                                                            "13px",

                                                                        fontWeight:
                                                                            "600"
                                                                    }}
                                                                >
                                                                    {h}
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontSize:
                                                                            "12px",

                                                                        opacity:
                                                                            0.9
                                                                    }}
                                                                >
                                                                    {
                                                                        resolved.label
                                                                    }
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        fontSize:
                                                                            "10.5px",

                                                                        opacity:
                                                                            0.75
                                                                    }}
                                                                >
                                                                    {
                                                                        cap > 0
                                                                            ?
                                                                            `${used}/${cap} • ${Math.round((used / cap) * 100)}%`
                                                                            :
                                                                            "-"
                                                                    }
                                                                </div>

                                                            </div>

                                                        );
                                                    }


                                                    //------------------------------------------------
                                                    // Desk
                                                    //------------------------------------------------

                                                    return (

                                                        <div
                                                            key={h}
                                                            style={{
                                                                display:
                                                                    "flex",

                                                                justifyContent:
                                                                    "space-between",

                                                                marginBottom:
                                                                    "4px",

                                                                padding:
                                                                    "4px 6px",

                                                                //------------------------------------------------
                                                                // Flat - tiny radius retained on data cells
                                                                //------------------------------------------------

                                                                borderRadius:
                                                                    "2px",

                                                                color:
                                                                    "#fff",

                                                                fontSize:
                                                                    "12px",

                                                                ...getDeskStyle(
                                                                    record
                                                                )
                                                            }}
                                                        >

                                                            <span>
                                                                {h}
                                                            </span>

                                                            <span>
                                                                {
                                                                    getDeskLabel(
                                                                        record
                                                                    )
                                                                }
                                                            </span>

                                                        </div>

                                                    );

                                                }
                                            )
                                        }

                                    </div>

                                );

                            }
                        )
                    }

                </div>

            </div>


            {/* ------------------------------------------------
                Footer
                ------------------------------------------------ */}

            <div
                style={{
                    padding:
                        "15px",

                    borderTop:
                        "1px solid rgba(255,255,255,0.08)",

                    textAlign:
                        "right"
                }}
            >

                <button
                    onClick={onClose}
                    style={{
                        background:
                            "linear-gradient(180deg,#263548 0%,#182536 100%)",

                        color:
                            "#e5e7eb",

                        border:
                            "1px solid rgba(255,255,255,0.12)",

                        borderBottom:
                            "2px solid #20afe8",

                        padding:
                            "8px 18px",

                        borderRadius:
                            "0px",

                        cursor:
                            "pointer",

                        boxShadow:
                            "0 4px 12px rgba(0,0,0,0.18)"
                    }}
                >
                    Close
                </button>

            </div>

        </div>

    );

}